import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface DeleteRecurringEventDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (deleteAll: boolean) => void;
  eventTitle?: string;
}

const DeleteRecurringEventDialog: React.FC<DeleteRecurringEventDialogProps> = ({
  open,
  onClose,
  onConfirm,
  eventTitle,
}) => {
  const { t } = useTranslation();
  const [deleteOption, setDeleteOption] = useState<'single' | 'all'>('single');

  const handleConfirm = () => {
    onConfirm(deleteOption === 'all');
    onClose();
  };

  const handleClose = () => {
    setDeleteOption('single'); // Reset al cerrar
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          //@ts-ignore
          backgroundColor: (theme) => theme.palette.background.panel,
        },
      }}
    >
      <DialogTitle>{t('calendar.deleteRecurringEvent', 'Borrar evento recurrente')}</DialogTitle>

      <DialogContent>
        {eventTitle && (
          <Box sx={{ mb: 2, color: 'text.secondary', fontSize: '0.875rem' }}>"{eventTitle}"</Box>
        )}

        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            value={deleteOption}
            onChange={(e) => setDeleteOption(e.target.value as 'single' | 'all')}
          >
            <FormControlLabel
              value="single"
              control={<Radio color="secondary" />}
              label={t('calendar.deleteThisEvent', 'Este evento')}
              sx={{ mb: 1 }}
            />
            <FormControlLabel
              value="all"
              control={<Radio color="secondary" />}
              label={t('calendar.deleteAllEvents', 'Todos los eventos')}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: '8px' }}
        >
          {t('global.cancel', 'Cancelar')}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          sx={{ borderRadius: '8px' }}
        >
          {t('global.delete', 'Eliminar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteRecurringEventDialog;
